import { render, staticRenderFns } from "./OrderDetailItem.vue?vue&type=template&id=f4fc7a20&scoped=true"
import script from "./OrderDetailItem.vue?vue&type=script&lang=js"
export * from "./OrderDetailItem.vue?vue&type=script&lang=js"
import style0 from "./OrderDetailItem.vue?vue&type=style&index=0&id=f4fc7a20&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4fc7a20",
  null
  
)

export default component.exports